// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  basePictureURL: 'https://cdiwork.com:8085/',
  socketURL: "https://cdiwork.com:8085",
  baseURL: "https://cdiwork.com:8085/api/",
  baseURLv2: "https://cdiwork.com:8085/api/v2/",
  production: true,
  firebaseConfig : {
    apiKey: "AIzaSyCG8gI7YDbtSfXPWbaSJsFN4XweV5WMOcg",
    authDomain: "gobezpro.firebaseapp.com",
    projectId: "gobezpro",
    storageBucket: "gobezpro.appspot.com",
    messagingSenderId: "418064635806",
    appId: "1:418064635806:web:aacfc9c8dec7bd675de88f"
  },
  vapidKey: 'BIDoouCz8kjYnocVXamAEwmY_DFMYmNufrdb8cT2O4G50VqzwKxJGzp1I1P6k6a14idG0ifLsVs0gcNKBQdu4-0',
  onlineUsers: {
    firebaseID: "CLJUkEdqCBaIPSI3gmnCv24FC7T2",
    userID: "0vgGd2T1DrAuIT_HAAIj"
 },
stripePublicKey: "pk_live_51Pi11nRtTUG0mDAaLMANjooN9qJmbno9VADauMHVyMJ4CjA9r5XaDZ8yHhdmWcZpjFTayc8SNF2obvjkYn75t3R900YiwUZvny"
};


/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
